angular.module('agreements')
    .constant('AgreementAccessGroupConst', {
        eventUpdate: 'agreement-access-group.updated'
    })
    .factory('AgreementAccessGroup', function ($resource) {
        return $resource('/crm/api/agreement-access-group/:id', { id: '@id' }, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            autocomplete: { method: 'GET', isArray: true, url: '/crm/api/agreement-access-group/autocomplete' },
        })
    })
    .service('AgreementAccessGroupService', function ($rootScope, modals, AgreementAccessGroup, AgreementAccessGroupConst) {
        this.add = params => {
            let entity = {
                id: null,
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            return modals.open('app/agreements/access-group/edit-modal.html', 'AgreementAccessGroupDialogController', angular.copy(entity), {}, "$ctrl")
        }
        this.list = () => {
            return modals.open('app/agreements/access-group/list-modal.html', 'AgreementAccessGroupListController', {}, {size: 'md'}, "$ctrl")
        }
        this.remove = function (item) {
            return modals.confirmDelete(item.name, () => AgreementAccessGroup.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(AgreementAccessGroupConst.eventUpdate)))
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('agreementAccessGroupList', {
            parent: 'app',
            url: '/agreement-access-group?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'agreementAccessGroupList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (AgreementAccessGroup, $q, $stateParams) => AgreementAccessGroup.list(angular.copy($stateParams)).$promise
            }
        })
    })
